import Actions from '../../action'
const initialState = {
    isLoading: false,
    subscriptionList: [],
    error: false
}
export default (state = initialState, action = {}) => {
    switch (action.type) {
        case Actions.GET_SUBSCRIPTION_LIST: {
            return {
                ...state,
                isLoading: true,
            };
        }
        case Actions.GET_SUBSCRIPTION_LIST_SUCCESS: {
            return {
                ...state,
                isLoading: false,
                subscriptionList: action.data.response,
                error: false
            };
        }
        case Actions.GET_SUBSCRIPTION_LIST_FAILURE: {
            return {
                ...state,
                isLoading: false,
                error: action.error,
            };
        }
        default:
            return state;
    }
};


